export default {"src":"/_next/static/media/fill-in-blank-mini.318d14fb.svg","height":24,"width":24};